import { Stack } from "@mui/material";
import { useMemo } from "react";
import type { CustomMeasureReturnType } from "../hooks/useCustomMeasure";
import FunctionPropertyItem from "./FunctionPropertyItem";
import VariablePropertyItem from "./VariablePropertyItem";

interface Props {
  state: CustomMeasureReturnType;
  editable: boolean;
}

const Properties = ({ state, editable }: Props) => {
  const chartOfAccountItems = useMemo(() => {
    return state.chartOfAccounts?.gl.concat(state.chartOfAccounts?.memo);
  }, [state.chartOfAccounts?.gl, state.chartOfAccounts?.memo]);

  return (
    <Stack
      spacing={2}
      useFlexGap
      sx={{
        overflowY: "auto",
        overflowX: "hidden",
        width: "100%",
        py: 2,
        pl: 2.5,
        pr: 3,
      }}
    >
      {state.formulaNodes.map((fn, i) => {
        if (fn.function !== undefined) {
          return (
            <FunctionPropertyItem
              // eslint-disable-next-line @eslint-react/no-array-index-key
              key={i}
              formulaNode={fn}
              state={state}
              editable={editable}
              chartOfAccountItems={chartOfAccountItems}
            />
          );
        }
        return (
          <VariablePropertyItem
            // eslint-disable-next-line @eslint-react/no-array-index-key
            key={i}
            formulaNode={fn}
            state={state}
            editable={editable}
            chartOfAccountItems={chartOfAccountItems}
          />
        );
      })}
    </Stack>
  );
};

export default Properties;
